var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 833,
    viewBox: "0 0 1920 833",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M255 689.959C-41 743.959 -41 776.459 -41 776.459V1153.46C644 1183.46 2025.4 1222.46 2071 1138.46C2128 1033.46 2065 54.9594 2047 4.45942C2029 -46.0406 1836.95 349.479 1634 327.959C1431.05 306.44 1135.04 214.397 955 348.959C774.957 483.522 551 635.959 255 689.959Z",
    fill: "#A48FF8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWave);
export default __webpack_public_path__ + "static/media/wave.675191b28cf6c096af9ec487a50ca9cd.svg";
export { ForwardRef as ReactComponent };